(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-occasion-hero"] && !Shopify.designMode) return;
  try {
    
  class AccioHeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.accio-hero__track');
      this.slides = Array.from(this.querySelectorAll('.accio-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-index]'));
      this.current = 0;
      this.interval = Number(this.dataset.interval || 7000);
      this.autoplay = this.dataset.autoplay === 'true';
      this.suspended = false;
      this.pendingAdvance = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelector('.accio-hero__arrow--previous')?.addEventListener('click', () => this.goTo(this.current - 1));
      this.querySelector('.accio-hero__arrow--next')?.addEventListener('click', () => this.goTo(this.current + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slideIndex))));

      this.addEventListener('mouseenter', () => this.suspendAutoplay());
      this.addEventListener('mouseleave', () => this.resumeAutoplay());
      this.addEventListener('focusin', () => this.suspendAutoplay());
      this.addEventListener('focusout', () => this.resumeAutoplay());

      this.querySelectorAll('.accio-hero__video').forEach((video) => {
        video.loop = false;
        video.muted = true;
        video.addEventListener('ended', () => this.handleVideoEnded(video));
      });

      if (!this.reducedMotion && this.slides.length > 0) {
        const firstSlide = this.slides[0];
        firstSlide.classList.remove('is-active');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => firstSlide.classList.add('is-active'));
        });
        this.playCurrentVideo(false);
        this.scheduleCurrentSlide();
      }
    }

    disconnectedCallback() {
      this.clearTimer();
      this.pauseVideos();
    }

    goTo(index) {
      if (this.slides.length === 0) return;

      this.clearTimer();
      this.pauseVideos(true);
      this.pendingAdvance = false;

      const nextIndex = (index + this.slides.length) % this.slides.length;
      this.current = nextIndex;
      this.track.style.transform = 'translateX(-' + (nextIndex * 100) + '%)';

      this.slides.forEach((slide, slideIndex) => {
        slide.classList.remove('is-active');
        slide.setAttribute('aria-hidden', String(slideIndex !== nextIndex));
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === nextIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });

      window.requestAnimationFrame(() => this.slides[nextIndex].classList.add('is-active'));
      this.playCurrentVideo(true);
      this.scheduleCurrentSlide();
    }

    currentVideo() {
      return this.slides[this.current]?.querySelector('.accio-hero__video') || null;
    }

    playCurrentVideo(restart) {
      const video = this.currentVideo();
      if (!video || this.reducedMotion) return;

      if (restart || video.ended) video.currentTime = 0;
      const playPromise = video.play();
      if (playPromise) {
        playPromise.catch(() => {
          if (this.autoplay && !this.suspended) {
            this.timer = window.setTimeout(() => this.goTo(this.current + 1), this.interval);
          }
        });
      }
    }

    pauseVideos(reset = false) {
      this.querySelectorAll('.accio-hero__video').forEach((video) => {
        video.pause();
        if (reset) video.currentTime = 0;
      });
    }

    handleVideoEnded(video) {
      if (video !== this.currentVideo()) return;

      if (this.autoplay && !this.suspended && !this.reducedMotion) {
        this.goTo(this.current + 1);
      } else {
        this.pendingAdvance = true;
      }
    }

    scheduleCurrentSlide() {
      this.clearTimer();
      if (!this.autoplay || this.suspended || this.reducedMotion || this.slides.length <= 1) return;

      if (!this.currentVideo()) {
        this.timer = window.setTimeout(() => this.goTo(this.current + 1), this.interval);
      }
    }

    suspendAutoplay() {
      this.suspended = true;
      this.clearTimer();
    }

    resumeAutoplay() {
      this.suspended = false;

      if (this.pendingAdvance) {
        this.pendingAdvance = false;
        this.goTo(this.current + 1);
        return;
      }

      const video = this.currentVideo();
      if (video) {
        if (video.ended) {
          this.goTo(this.current + 1);
        } else if (video.paused) {
          this.playCurrentVideo(false);
        }
      } else {
        this.scheduleCurrentSlide();
      }
    }

    clearTimer() {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('accio-hero-slideshow')) {
    customElements.define('accio-hero-slideshow', AccioHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yalindars-first-batch-fixes"]) return;
  try {
    
  const resizeYalindarsWhatsApp = () => {
    const host = document.querySelector('gty-whatsapp-chat-button');
    const root = host && host.shadowRoot;
    const wrapper = root && root.querySelector('.gty-wacb-wrapper');
    const button = root && root.querySelector('.gty-wacb-button');
    if (!wrapper) return false;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const buttonSize = isMobile ? '52px' : '64px';
    wrapper.style.right = isMobile ? '16px' : '24px';
    wrapper.style.bottom = isMobile ? '88px' : '32px';
    if (button) {
      button.style.width = buttonSize;
      button.style.height = buttonSize;
      button.style.minWidth = buttonSize;
      button.style.minHeight = buttonSize;
    }
    return true;
  };

  const initializeYalindarsWhatsApp = () => {
    resizeYalindarsWhatsApp();
    const observer = new MutationObserver(() => {
      if (resizeYalindarsWhatsApp()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 12000);
    window.addEventListener('resize', resizeYalindarsWhatsApp, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeYalindarsWhatsApp, { once: true });
  } else {
    initializeYalindarsWhatsApp();
  }

  } catch(e) { console.error(e); }
})();
})();
